/*
 filtersEditor

 This component represents the filters editor.

 */

import ko from 'knockout';
import _ from 'lodash';
import { reportFiltersEditor } from '../filters';

ko.components.register('report-filters-editor-dialog', {
    viewModel: reportFiltersEditorDialog,
    template: {
        element: 'report-filters-editor-dialog-template'
    }
});

export function reportFiltersEditorDialog(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof reportFiltersEditorDialog)
        return data;

    self.reportFiltersEditor = ko.observable(new reportFiltersEditor());
    self.onApplyCallback = data.onApplyCallback;
    self.cancelButtonClick = data.onCancelCallback;

    self.saveFiltersButtonClick = function () {
        saveFilters();
    }

    self.applyFiltersButtonClick = function () {
        //Check to make sure filters are valid
        if (!self.reportFiltersEditor().filtersAreValid())
            return;

        //Get the filters and save them
        var filters = self.reportFiltersEditor().getFilters();

        if (!_.isNullOrUndefined(self.onApplyCallback)) {
            self.onApplyCallback(filters);
        }
    }

    var init = function (data) {

        self.reportFiltersEditor(
            new reportFiltersEditor({
                getReportColumnsDataPromise: data.getReportColumnsDataPromise,
                getReportColumnsDataPromiseArgs: [],
                getReportFiltersDataPromise: data.getReportFiltersDataPromise,
                getReportFiltersDataPromiseArgs: [],
                getListOfValuesColumnsDataPromise: data.getListOfValuesColumnsDataPromise,
                onLoadFailedCallback: null,
                editorSourceType: "Report"
            }));
    }

    init(data);
}